<script>
    import { convert, isTouchDevice } from '../../ui';
	//import PositiveVpSrc from '$lib/assets/vp/vp-positive.png';
	//import type { SpecialtyTrack } from '$lib/models/Data';
	import { dbHover, dbUnhover, dbClick} from './dashfuncs';

	export let trackValues;
	export let topOffset;
	export let isAdvanced;
	export let p;
	export let preview;
	export let track;
	export let verticalInvert = false;
	export let rewards = {};

	let horizontals = [6.8, 12.5, 17.8, 23.5, 28.8, 34.5, 39.8, 45.5, 50.8, 56.5, 61.8, 67.5, 72.8, 78.5, 83.8, 89.5];
	let verticals = [7, 8.5]

	const calculateValues = (parsed, advanced) => {
		return parsed; // None of below is needed because app already handles basic OK
		if (advanced || Object.keys(parsed).length < 1) return parsed;
		const values = {
			0: 1
		};
		Object.keys(parsed).forEach((key) => {
			const keyInt = parseInt(key);
			values[keyInt] = parsed[keyInt] + 1;
		});
		return values;
	};

	function getHorizontals(t){
		if(t <= 15) return horizontals[t];
		if(t <= 30) return horizontals[t - 15];
		return horizontals[t - 30];
	}

	function getThreshold(t){
		if(t <= 15) return t;
		if(t <= 30) return t - 15;
		return t - 30;
	}

	function getOffset(t){
		if(t <= 15) return 0;
		if(t <= 30) return 19.25;
		return 38.5;
	}

	function getMultOffset(t){
		if(t <= 15) return 0;
		if(t <= 30) return 500;
		return 1000;
	}

	$: actualValues = calculateValues(trackValues, isAdvanced);


</script>

<div class="track-wrapper" style="top: {topOffset}%"
	on:mouseenter={e => {dbHover(e, p, preview, 'track')}}
	on:mousemove={e => {dbHover(e, p, preview, 'track')}}
	on:mouseleave={e => {dbUnhover(e, p)}} 
	on:click={e => {if(!preview && !isTouchDevice()) dbClick(p, 'track'); } } 
	on:touchstart={e => {if(!preview && isTouchDevice()) dbClick(p, 'track'); } } 
>
	{#each Object.keys(actualValues) as threshold}
		<div class="multiplier" style="--offset:{getThreshold(threshold)}; top:{getMultOffset(threshold)}%;">
			<img src="assets/vp/vp-positive.png" alt="thr-{threshold}" />
			<div class="multiplier-label font-body" >{`X${actualValues[parseInt(threshold)]}`}</div>
		</div>
	{/each}
	{#each Object.keys(rewards) as threshold}
		<div class="multiplier" style="--offset:{getThreshold(threshold)}; top:{getMultOffset(threshold)}%; font-size: 1.2em;">
			{@html convert(`[[${rewards[threshold]}]]`)}
		</div>
	{/each}
	<div class="marker {track}" style="top: calc(var(--height) / {verticals[(p[track] + verticalInvert ? 1 : 0) % 2]} + {getMultOffset(p[track])}%); left: {getHorizontals(p[track])}%;"></div>
</div>

<style lang="scss">
	.marker {
		position: absolute;
		width: calc(var(--height) / 11);
    	height: calc(var(--height) / 11);
		outline: 2px solid white;
		transition: left 0.5s, top 0.5s;
	}

	.research {
		background-color: cornflowerblue;
	}

	.military {
		background-color: red;
	}
	
	.influence {
		background-color: yellow;
	}

	.treachery {
		background-color: rgba(189, 107, 11, 1);;
	}

	.collective {
		background-color: green;
	}

	.track-wrapper {
		position: absolute;
		width: 100%;
		height: calc(var(--height) / 13.367); //30px;
		pointer-events: all;
	}
	.multiplier {
		position: absolute;
		left: calc(7.5% + (var(--offset) * 5.51%));
		& > img {
			width: 1.6em;
		}
	}
	@mixin stroke($color: #000, $size: 1px) {
		text-shadow: -#{$size} -#{$size} 0 $color, 0 -#{$size} 0 $color, #{$size} -#{$size} 0 $color,
			#{$size} 0 0 $color, #{$size} #{$size} 0 $color, 0 #{$size} 0 $color,
			-#{$size} #{$size} 0 $color, -#{$size} 0 0 $color;
	}
	.multiplier-label {
		position: absolute;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;
		font-size: calc(var(--height) / 28.643); //14px;
		font-weight: 800;
		line-height: 1;
		@include stroke(#fff, 1px);
	}
</style>
